import { BoxProps, TextProps as TextStyle, BoxProps as ViewStyle } from '@jfs/ui-new'
import { Colors } from '../../util/util'

const styles = (breakpoint: number): any => {
  let overideMainContainer: ViewStyle = {}
  let overideContainer: ViewStyle = {}
  let overideTitleContainer: ViewStyle = {}
  let overideFooterStyle: ViewStyle = {}
  let overideTitle: ViewStyle = {}
  const isMobile = breakpoint < 620

  return {
    mainContainer: {
      display: 'flex',
      position: 'relative',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
      overflow: 'auto',
      backgroundColor: Colors.JIO_PRIMARY,
      ...overideMainContainer,
    } as ViewStyle,
    container: {
      // display: 'flex',
      flex: 1,
      width: isMobile ? '90%' : '100%',
      // flexDirection: 'row',
      // justifyContent: 'center',
      alignItems: 'center',
      flexWrap: 'wrap',
      ...overideContainer,
    } as ViewStyle,
    rowContainerStyle: { flexDirection: 'row' } as ViewStyle,
    cardContainer: {
      // flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      flex: 1,
      marginTop: isMobile ? 32 : 60,
    } as ViewStyle,
    titleContainer: {
      width: isMobile ? 300 : 551,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'center',
      ...overideTitleContainer,
    } as ViewStyle,
    iconContainer: {
      flexDirection: 'row',
      // alignSelf: 'center',
      align: 'center',
      alignSelf: 'center',
      paddingTop: isMobile ? 16 : 0,
    } as ViewStyle,
    card: {
      backgroundColor: Colors.WHITE,
      alignItems: 'center',
      shadowColor: Colors.HALF_WHITE,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.3,
      shadowRadius: 4,
      zIndex: 4,
      width: isMobile ? '100%' : undefined,
      minWidth: isMobile ? undefined : 308,
      borderRadius: 16,
      // marginHorizontal: 16,
    } as ViewStyle,
    loginFormCard: {
      // alignItems: 'center',
      justifyContent: isMobile ? 'center' : 'flex-start',
      width: '100%',
      maxWidth: '100%',
      // height: isMobile ? 392 : 424,
      paddingHorizontal: 22,
      paddingVertical: 20,
    } as ViewStyle,
    loginBtnContainerStyle: {
      alignItems: 'center',
      marginBottom: isMobile ? 4 : 10,
      paddingHorizontal: isMobile ? 0 : 32,
    } as ViewStyle,
    eyeImgStyle: { height: 20, width: 20 } as ViewStyle,
    margin: { height: 24 } as ViewStyle,
    payStyle: {
      color: Colors.WHITE,
      fontSize: isMobile ? 16 : 24,
      fontWeight: '700',
      alignSelf: 'center',
    } as TextStyle,
    title: {
      color: Colors.WHITE,
      opacity: 0.25,
      fontSize: 56,
      fontWeight: '900',
      marginTop: 40,
      marginStart: 8,
      textAlign: 'left',
      display: isMobile ? 'none' : 'flex',
      ...overideTitle,
    } as TextStyle,
    loginTitleStyle: {
      color: 'BLACK',
      fontSize: isMobile ? 20 : 28,
      fontWeight: 'bold',
    } as TextStyle,
    formContainerStyle: {
      maxWidth: isMobile ? '100%' : undefined,
    } as ViewStyle,
    errorStyle: { color: Colors.ERROR } as TextStyle,
    signUpStyle: {
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 32,
    } as BoxProps,
    dontHaveAccStyle: {
      color: Colors.WHITE,
      fontSize: 12,
    } as ViewStyle,
    loginExtraItemStyle: {
      flexDirection: 'row',
      marginTop: 0,
      marginStart: 4,
      alignItems: 'center',
      justifyContent: 'space-between',
    } as BoxProps,
    forgotPwdTextStyle: {
      color: Colors.PRIMARY,
      fontSize: 12,
      fontWeight: 'MEDIUM',
      height: 14,
    } as TextStyle,
    signUpText: {
      color: 'WHITE',
      fontSize: 12,
      fontWeight: 'bold',
    } as TextStyle,
    loginButton: {
      mt: 16,
      borderWidth: 1,
      borderColor: 'WHITE',
      borderRadius: 8,
      paddingVertical: 8,
      paddingHorizontal: 25,
      underlayColor: 'TRANSPARENT',
    } as BoxProps,
    footerStyle: {
      flexDirection: 'row',
      justifyContent: isMobile ? 'center' : 'flex-end',
      alignItems: 'center',
      alignSelf: isMobile ? 'center' : 'flex-end',
      flexWrap: 'wrap',
      marginVertical: 8,
      opacity: 0.5,
      ...overideFooterStyle,
    } as ViewStyle,
    dotStyle: { fontSize: 4, color: Colors.WHITE } as TextStyle,
    scrollView: { width: '100%' },
  }
}

export { styles }
